<template>
<div class="tab-item" v-show="isActive">
  <slot></slot>
</div>
</template>

<script>
export default {
  data(){ return {
    isActive: false
  }},

  props: {
    name: String,
    selected: {
      type: Boolean,
      default: false
    }
  },

  mounted(){
    this.isActive = this.selected;
  }
}
</script>



// WEBPACK FOOTER //
// tab.vue?8ec29ce6